var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailSendLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2667_10440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.75 4.25C27.4404 4.25 28 4.80965 28 5.5V25.5082C28 26.194 27.4309 26.75 26.7603 26.75H4.23975C3.55506 26.75 3 26.1939 3 25.5082V24.25H25.5V9.625L15.5 18.625L3 7.375V5.5C3 4.80965 3.55965 4.25 4.25 4.25H26.75ZM10.5 19.25V21.75H0.5V19.25H10.5ZM6.75 13V15.5H0.5V13H6.75ZM24.9574 6.75H6.04268L15.5 15.2616L24.9574 6.75Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2667_10440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailSendLine);
export default __webpack_public_path__ + "static/media/mail-send-line.73239cb02f867050cadf42b299a79f7f.svg";
export { ForwardRef as ReactComponent };